import { Injectable } from '@angular/core';
import { SectionIdentifier, SectionReview, SectionStatus } from './review-section.domain';
import { combineLatest, Observable } from 'rxjs';
import { ReviewSectionStore } from './review-section.store';
import { map } from 'rxjs/operators';
import { OrderProcesStore } from '../../stores/order-process.store';
import { OrderProcessData } from 'src/app/jurisdiction-overview/jurisdiction-overview.domain';

@Injectable({
  providedIn: 'root',
})
export class ReviewSectionSelectors {
  constructor(private store: ReviewSectionStore, private orderProcessStore: OrderProcesStore) {}

  public getSectionReview(applicationId: number, sectionIdentifier: SectionIdentifier): Observable<SectionReview> {
    return this.store.reviews.pipe(
      map(reviews => reviews.find(review => review.section == sectionIdentifier && review.application_id == applicationId))
    );
  }

  public isSectionWaitingForUpdate(applicationId: number, sectionIdentifier: SectionIdentifier): Observable<boolean> {
    return combineLatest([this.getSectionReview(applicationId, sectionIdentifier), this.orderProcessStore.getOrderProcessValue()]).pipe(
      map(([sectionReview, orderProcess]: [SectionReview, OrderProcessData]) => {
        return sectionReview?.status === SectionStatus.rejected && orderProcess?.sk_executor_action === 'update_application';
      })
    );
  }
}
